'use strict';

define('features/iframe',[
  'jquery',
  'lib/util/zip',
  'cookies',
  'responsive',
  'bat',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  // 'lib/analytics/click',
  'lib/analytics/context.add',
], function (
  $,
  zip,
  cookies,
  responsive,
  bat,
  blocks,
  anPageLoad,
  // anClicks,
  anAddContext
) {
  var __initialized = false;

  function __addZip(url) {
    var incUrl = url;
    if (!incUrl.includes('ZipCode=')) {
      incUrl += '&ZipCode=';
    }
    return incUrl.replace('&ZipCode=', '&ZipCode=' + zip.getCookiedDefaultFallback());
  }

  var Iframe = function (el, config) {
    this.el = $(el);
    this._config = Object.assign({}, config);
    this.config = config;
    this.initialize.apply(this, arguments);
  };

  $.extend(Iframe.prototype, {
    initialize: function (el, config) {
      this.isKbb = config.iframe_url.indexOf('kbb.com') >= 0;
    },

    load: function () {
      var self = this;
      var config = this.config;

      if (self.isKbb) {
        self.loadKbb();
      }
      __initialized = true;
      if (config.iframe_mode && (responsive() === 'sm' || responsive() === 'md')) {
        self.el.html('<iframe height="' + config.iframe_mobile_height + '" frameborder="0" src="' + config.iframe_mobile_url + '" class="frame-phone col-sm-12" style="overflow: hidden;" id="ldtiAutoResize0"></iframe>');
        $('.iframe-wrapper .frame-phone').show();
      } else {
        self.el.html('<iframe height="' + config.iframe_height + '" frameborder="0" src="' + config.iframe_url + '" class="frame-other col-lg-12" style="overflow: hidden;" id="ldtiAutoResize1"></iframe>');
      }

      $(window).on('ZIP_CODE_CHANGED', function () {
        self.load();
      });

      self.analytics();
    },

    loadKbb: function () {
      if (cookies.getItem('isConfirmedZip') === 'true') {
        // always use the original URL that lives on self._config.
        // Prevents double zips on zip change
        this.config.iframe_mobile_url = __addZip(this._config.iframe_mobile_url);
        this.config.iframe_url = __addZip(this._config.iframe_url);
      }

      if (!__initialized) {
        var kbbResize = document.createElement('script');
        kbbResize.setAttribute('src', '/assets/js/AutoResize.js');
        document.head.appendChild(kbbResize);
        bat.util.loader.hideLoader();
      }
    },

    analytics: function () {
      var $scope = this.el;

      anAddContext(
        $scope,
        blocks.sectionBlock('Trade in value')
      );
      // anClicks($scope);
      anPageLoad($scope);
    },
  });

  return Iframe;
});

